import { render, staticRenderFns } from "./GeneralConfigurationComponent.vue?vue&type=template&id=a0e19902&"
import script from "./GeneralConfigurationComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralConfigurationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports